import { render, staticRenderFns } from "./AdminCases.vue?vue&type=template&id=7fee15b7"
import script from "./AdminCases.vue?vue&type=script&lang=js"
export * from "./AdminCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports